import React from 'react';
import PropTypes from 'prop-types';

class Dropdown extends React.Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
        selected: PropTypes.bool,
        children: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.object
        ]).isRequired
    }

    render() {
        const { selected, children } = this.props;

        return (
            <div className='ely-dropdown-container'>
                <div className={`ely-dropdown ${selected ? 'selected' : ''}`}>
                    <div className='text'>. . .</div>
                    <ul>
                        {children}
                    </ul>
                </div>
            </div>
        );
    }
}

export class DropdownItem extends React.Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        selected: PropTypes.string,
    }

    render() {
        const { selected, name, onClick } = this.props;

        return (
            <li 
                className={`ely-dropdown-item ${selected === name ? 'selected' : ''}`}
                onClick={onClick}>{name}
            </li>
        );
    }
}

export default Dropdown;
